<template>
  <b-row>
    <div
      id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 50%;">
        <img src="../../assets/loader.gif" />
      </p>
    </div>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <div slot="header" v-html="caption"></div>
          <div v-if="data.length > 0">
            <b-table
            style="overflow-    x:auto!important;"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="data"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              class="table-responsive cnt"
            >
              <template slot="link" slot-scope="data">
                <span style="padding-left:20px!important;">
                  <a :href="data.item.link" target="blank">Click Here</a>
                </span>
              </template>
              <template slot="_id" slot-scope="data">
                <span style="padding-left:20px!important;">
                  <router-link :to="'/rescuesingleloc/'+data.item._id ">
                    <b-button variant="success"><i class="fa fa-map-marker"></i></b-button>
                  </router-link>
                </span>
                <span  style="padding-left:20px!important;padding-bottom:20px!important;">
                  <router-link :to="'/editrescuecenter/'+data.item._id ">
                    <button class="btn btn-info text-white" variant="light"><i class="fa fa-edit"></i></button>
                  </router-link>
                </span>
                
                <span style="padding-left:20px!important;">
                  <b-button variant="danger" @click="delcnt(data.item._id)"><i class="fa fa-trash"></i></b-button>
                </span>
              </template>
            </b-table>
            <nav>
              <b-pagination
                size="sm"
                :total-rows="getRowCount(data)"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              />
            </nav>
          </div>
          <div v-else>
            <p>No List Found</p>
          </div>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  name: "Users",
  props: {
    caption: {
      type: String,
      default: "List of Rescue Centers"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      type: localStorage.getItem("type"),
      errors: [],
      data: [],
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt rclwd"
        },
        {
          key: "email[0]",
          label: "Email",
          sortable: false,
          thClass: " cnt rclwd",
          tdClass: "cnt rclwd"
        },
        {
          key: "phone",
          label: "Mobile",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt rclwd10"
        },
          {
          key: "address",
          label: "address",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt rclwd"
        },
        // {
        //   key: "state",
        //   label: "State",
        //   sortable: false,
        //   thClass: " cnt",
        //   tdClass: "cnt rclwd"
        // },
        {
          key: "link",
          label: "HTTP Link",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt "
        },

        {
          label: " Action",
          key: "_id",
          sortable: false,
          thClass: "cnt",
          tdClass: "cnt react"
        }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      loading: false
    };
  },
  mounted: function() {
    this.getList();
  },
  methods: {
    delcnt(val) {
      this.loading = true;
      if (confirm("Are you sure?")) {
        this.loading = true;
        var data1 = {};
        data1["id"] = val;
        data1["x-auth-token"] = localStorage.getItem("token");
        axios({
          method: "POST",
          data: data1,
          url: "/rescue/remove/"
        })
          .then(response => {
            this.loading = false;
            if (response.data.status) {
              this.getList();
              this.msg = response.data.msg;
            } else {
              this.loading = false;
              this.$router.push({ name: "rescueCentersList" });
            }
          })
          .catch(err => {
            this.loading = false;
            this.errors.push(err);
            this.$router.push({ name: "rescueCentersList" });
          });
      }
      else {
              this.loading = false;
              this.$router.push({ name: "rescueCentersList" });
            }
    },
    getList() {
      this.loading = true;
      axios({
        method: "GET",
        url: "rescue/getlist"
        // headers: {
        //   "x-auth-token": localStorage.getItem("token")
        // }
      })
        .then(response => {
          this.loading = false;

          if (response.data.status === true) {
            this.data = response.data.data;
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },

    getBadge(status) {
      return status === "sucess"
        ? "success"
        : status === "initiate"
        ? "secondary"
        : status === "progress"
        ? "warning"
        : status === "failure"
        ? "danger"
        : "primary";
    },
    getRowCount(data) {
      return data.length;
    }
    // userLink(id) {
    //   return `users/${id.toString()}`;
    // },
    // rowClicked(data) {
    //   const userLink = this.userLink(data._id);
    //   this.$router.push({ path: userLink });
    // }
  }
};
</script>

<style>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.cnt {
  text-align: center !important;
}
.rclwd {
  width: 100px !important;
  overflow: auto !important;
}
.rclwd10{
width: 200px !important;
}
.react{
  min-width: 200px !important;
}
</style>
